import { useEffect, useState } from 'react';
import api from '@services/api';

import type { PendingExecutionType } from './types';

const useGetPendingExecutions = () => {
  const [loading, setLoading] = useState(true);
  const [pendingExecutionDetails, setPendingExecutionDetails] = useState<PendingExecutionType | null>(null);
  const [showAllPendingExecutionsDialog, setShowAllPendingExecutionsDialog] = useState(false);

  const getPendingExecutions = async () => {
    setLoading(true);
    try {
      const response = await api.get('/campaign_execution/pending');
      setPendingExecutionDetails(response.data);
      if (response.data.open_dispositions > 0) {
        setShowAllPendingExecutionsDialog(true);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPendingExecutions();
  }, []);

  return {
    pendingExecutionDetails,
    showAllPendingExecutionsDialog,
    loading,
    closeAllPendingExecutionsDialog: () => setShowAllPendingExecutionsDialog(false),
  };
};

export default useGetPendingExecutions;
